import './App.css';
import Navbar from "./Navbar";
import Hero from "./Hero";
import Features from "./Features";
import CTA from "./CTA";
import Footer from "./Footer";
import FloatingOrbs from "./FloatingOrbs";

function App() {
  return (
      <>
          <FloatingOrbs/>
          <Navbar/>
          <Hero/>
          <Features/>
          <CTA/>
          <Footer/>
      </>
  );
}

export default App;
